<template>
	<div class="coursenotice_wrap" :style="'height:'+height">
		<div class="seach_ipt">
			<el-select class="select_class" v-model="classN" placeholder="请选择班级" clearable @change="classChange">
		    <el-option
		      v-for="item in classList"
		      :key="item.id"
		      :label="item.name"
		      :value="item.id">
		    </el-option>
		  </el-select>
			<div class="select_box">
				<span>发布状态</span><i></i>
				<el-select v-model="pushStatus" placeholder="请选择" @change="pushStatusChange">
			    <el-option
			      v-for="item in options"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			  </el-select>
			</div>
			<el-input class="ipt" v-model="titleCont" @keyup.enter.native="searchList()" placeholder="请输入标题或者内容"></el-input>
			<el-button type="primary" icon="el-icon-search" @click="searchList()">查询</el-button>
			<el-button type="primary" class="add_notice" @click="addNotice()">添加</el-button>
		</div>
		<div class="notice_list" v-if="noticeList.length" v-loading="loading">
			<ul>
				<li class="notice_item" v-for="(item,index) in noticeList" :key="index">
					<div class="top_head">
						<div class="name_status"><b v-if="item.top == 1">【置顶】</b><span>开课通知</span><i :class="item.ispush == 1 ? 'blur':'grey'">{{handleStatus(item.ispush)}}</i></div>
						<div class="dataTime">{{item.createtime.slice(0,10)}}</div>
					</div>
					<p class="content" @click="toDetail(item)">{{item.title}}</p>
					<div class="bottom">
						<span>发送至：{{handleTeachClass(item.classIds)}}</span>
						<div class="imgBox">
              <ul>
                <li class="release" v-if="item.ispush == 0" @click="releases(item)"><span></span><i>发布</i></li>
                <li class="norelease" v-if="item.ispush == 1" @click="noRelease(item)"><span></span><i>取消发布</i></li>
                <li class="edit" v-if="item.ispush == 0" @click="editNotice(item)"><span></span><i>编辑</i></li>
                <li class="del" @click="deleteNotice(item)"><span></span><i>删除</i></li>
              </ul>
						</div>
					</div>
				</li>
			</ul>
			<pagination
        :currentpage="pageTotal.currentPage"
        :pageSize="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="prev, pager, next, jumper"
        v-on:currentPageFn="currentPageFn"
        :current-page.sync="pageTotal.currentPage"
        v-if="noticeList.length && (pageTotal.total>pageTotal.pageSize)"
      ></pagination>
		</div>
		<div class="noList" v-else>
			<img src="../../../../../static/images/common/noorder_pic.png"/>
			<p>暂无通知</p>
		</div>
		<!--添加课程通知-->
		<el-drawer
		  title="添加通知详情"
		  :visible.sync="drawer"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false">
		  <div class="drawer_content">
		  	<header>
		  		<span>{{titleTop}}</span><img @click="close()" src="../../../../../static/images/close.png"/>
		  	</header>
		  	<div class="content_into" :style="'height:'+drawerHeight">
		  		<div class="ipt">
			  		<p>标题：</p>
			  		<el-input v-model.trim="title" placeholder="请输入标题" maxlength="30"></el-input>
			  	</div>
			  	<div class="ipt">
			  		<p>内容：</p>
			  		<v-editor v-model="noticeContent" class="notice_content"></v-editor>
			  	</div>
			  	<div class="ipt">
			  		<p>教学班：</p>
			  		<div class="transfer">
			  			<div class="left">
			  				<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			  				<div class="checkbox">
			  					<el-checkbox-group v-model="checkedClass" @change="handleCheckedCitiesChange">
								    <el-checkbox v-for="item in classArr" :label="item.name" :key="item.id">{{item.name}}</el-checkbox>
								  </el-checkbox-group>
			  				</div>
			  			</div>
			  		</div>
			  	</div>
			  	<div class="ipt">
			  		<span class="ipt_label">是否置顶：</span>
			  		<el-radio-group v-model="topping" :disabled="indexNum>=5?true:false">
					    <el-radio :label="1">置顶</el-radio>
					    <el-radio :label="0">不置顶</el-radio>
					  </el-radio-group>
					  <span class="topNum" v-if="indexNum>=5">最多置顶5条哦！</span>
			  	</div>
			  	<div class="ipt">
			  		<span class="ipt_label">状态：</span>
			  		<el-radio-group v-model="release">
					    <el-radio :label="1">发布</el-radio>
					    <el-radio :label="0">不发布</el-radio>
					  </el-radio-group>
			  	</div>
			  	<div class="btn">
			  		<el-button @click="close()">取消</el-button>
						<el-button type="primary" @click="save()">保存</el-button>
			  	</div>
		  	</div>
		  </div>
		</el-drawer>
		<!--课程通知详情-->
		<el-drawer
		  title="课程通知详情"
		  :visible.sync="drawerDetail"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false"
		  class="drawerDetail">
		  <div class="drawer_detail">
		  	<header>
		  		<span>课程通知详情</span><img @click="closeDetail()" src="../../../../../static/images/close.png"/>
		  	</header>
		  	<div class="content_into" :style="'height:'+drawerHeight">
		  		<div class="cont">
		  			<h3>{{detailObj.title}}</h3>
		  			<p class="dataTime">{{detailObj.timeData}}</p>
		  			<p class="date_cont" v-html="detailObj.msgcontent"></p>
		  		</div>
		  		<p class="classNames">发送至：{{detailObj.className}}</p>
		  	</div>
		  </div>
		</el-drawer>
	</div>
</template>

<script>
	import vEditor from "@/components/wjlEditor/index.vue";
	import Pagination from "../../../paginator/paginator.vue";
	import * as api from "../../../../api/individualApi";
	export default {
		components:{
	    vEditor,
	    Pagination
	  },
		data(){
			return {
				height:window.innerHeight - 236+"px",
				drawerHeight:window.innerHeight - 85+'px',
				classList:[],
        classN:'',
				titleCont:'',
				options: [{
					label: '全部',
          value: ''
        }, {
        	label: '已发布',
          value: '1'
        }, {
        	label: '未发布',
          value: '0'
        }],
        pushStatus: '',
        noticeList:[],
        drawer: false,
        direction: 'rtl',
        title:'',
        noticeContent:'',
        checkAll: false,
        checkedClass: [],
        classArr: [],
        isIndeterminate: false,
        checkedList:[],
        topping:1,
        release:1,
        drawerDetail: false,
        pageTotal: {
	        currentPage: 1,
	        pageSize: 10,
	        total: 0
	      },
	      classStr:'',
	      detailObj:{},
	      loading: true,
	      titleTop:'',
	      noticeId:'',
	      indexNum: 0,
			}
		},
		created(){
			this.getNoticeList();
			this.getAllTeachClass();
		},
		methods:{
			// 获取所有的教学班
			getAllTeachClass(){
				let courseId = this.$route.query.courseId;
				api.getAllTeachClass(courseId).then(res=>{
					if(res.code == 0){
						this.classList = res.data;
						this.classArr = res.data;
					}
				})
			},
			// 获取通知列表
			getNoticeList(){
				this.indexNum = 0;
				let obj = {
					"classId": this.classN,
					"courseId": this.$route.query.courseId,
					"pageNum": this.pageTotal.currentPage,
					"pageSize": this.pageTotal.pageSize,
					"param": this.titleCont,
					"pushStatus": this.pushStatus
				};
				api.getNoticeList(obj).then(res=>{
					console.log(res);
					if(res.code == 0){
						this.loading = false;
						this.noticeList = res.data.list;
						this.pageTotal.total = res.data.total;
						this.noticeList.forEach(val=>{
							if(val.top == 1){
								this.indexNum++;
							}
						})
					}else{
						this.$messageError(res.msg);
					}
				}).catch(error => {});
			},
			searchList(){
				this.pageTotal.currentPage = 1;
				this.getNoticeList();
			},
			pushStatusChange(val){
				this.pushStatus = val;
				this.getNoticeList();
			},
			classChange(val){
				this.classN = val;
				this.getNoticeList();
			},
			// 处理状态
			handleStatus(val){
				let str = '';
				switch (val){
					case 0:
						str = '未发布'
						break;
					case 1:
						str = '已发布'
						break;
					default:
						break;
				}
				return str
			},
			// 处理教学班展示
			handleTeachClass(arr){
				let className = '';
				arr.forEach(item=>{
					this.classList.forEach(v=>{
						if(item == v.id){
							className += v.name+'、';
						}
					})
				});
				return className.substr(0,className.length - 1);
			},
			// 添加打开课程通知
			addNotice(){
				this.drawer = true;
				this.checkedClass = [];
				this.checkedList = [];
				this.isIndeterminate = false;
				this.checkAll = false;
				this.release = 1;
				this.noticeContent = '';
				this.title = '';
				this.indexNum>=5?this.topping=0:this.topping=1
				this.titleTop = '添加通知';
			},
			// 编辑打开课程通知
			editNotice(item){
				this.drawer = true;
				this.titleTop = '编辑通知';
				this.title = item.title;
				this.noticeContent = item.msgcontent;
				this.topping = item.top;
				this.release = item.ispush;
				let newArr = [];
				item.classIds.forEach(v=>{
					this.classArr.forEach(item=>{
						if(item.id == v){
							newArr.push(item.name)
						}
					});
				})
				this.checkedClass = newArr;
				this.checkedList = newArr;
				if(this.classArr.length == this.checkedClass.length){
					this.isIndeterminate = false;
					this.checkAll = true;
				}else{
					this.isIndeterminate = true;
					this.checkAll = false;
				}
				this.noticeId = item.id;
			},
			// 保存
			save(){
				if(!this.title){
					this.$messageError('请填写标题');
					return;
				}
				if(!this.noticeContent){
					this.$messageError('请填写内容');
					return;
				}
				if(!this.checkedList.length){
					this.$messageError('请选择教学班');
					return;
				}
				let newArr = [];
				this.classArr.forEach(item=>{
					this.checkedList.forEach(v=>{
						if(item.name == v){
							newArr.push(item.id);
						}
					})
				})
				if(this.titleTop == '编辑通知'){
					let obj = {
						id:this.noticeId,
						classIds:newArr,
						courseId:this.$route.query.courseId,
						ispush:this.release,
						msgcontent:this.noticeContent,
						title:this.title,
						top:this.indexNum>=5?0:this.topping,
						objecttype:1
					};
					api.updateNotice(obj).then(res=>{
						if(res.code == 0){
							this.drawer = false;
							this.getNoticeList();
							this.$messageSuccess('修改成功');
						}else{
							this.$messageError(res.msg);
						}
					}).catch(error => {});
				}else if(this.titleTop == '添加通知'){
					let obj = {
						classIds:newArr,
						courseId:this.$route.query.courseId,
						ispush:this.release,
						msgcontent:this.noticeContent,
						title:this.title,
						top: this.indexNum>=5?0:this.topping,
						objecttype:1
					};
					api.addNotice(obj).then(res=>{
						if(res.code == 0){
							this.drawer = false;
							this.getNoticeList();
							this.$messageSuccess('添加成功');
						}else{
							this.$messageError(res.msg);
						}
					}).catch(error => {});
				}
			},
			// 删除通知
			deleteNotice(item){
				this.$tipsDialog(
					"提示",
      		"确定删除该通知吗？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
				).then(() => {
					api.delNotice(item.id).then(res=>{
						console.log(res);
						if(res.code == 0){
							this.getNoticeList();
							this.$messageSuccess('删除成功');
						}
					}).catch(error => {});
       	}).catch(() => {});
			},
			// 关闭
		  close(){
		   	this.drawer = false;
		  },
		  handleCheckAllChange(val) {
		  	if(val){
		  		this.checkedClass = [];
		  		this.classArr.forEach(item=>{
            this.checkedClass.push(item.name);
          })
		  	}else{
		  		this.checkAll = false;
          this.checkedClass = [];
		  	}
		  	this.checkedList = this.checkedClass;
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.classArr.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.classArr.length;
        this.checkedList = value;
      },
      delSelect(item,index){
      	this.checkedList.splice(index,1);
      	if(this.checkedList.length){
      		this.isIndeterminate = true;
      	}else{
      		this.isIndeterminate = false;
      		this.checkAll = false;
      	}
      },
      // 查看详情
      toDetail(item){
      	this.drawerDetail = true;
      	this.detailObj = item;
      	this.detailObj.className = this.handleTeachClass(this.detailObj.classIds);
      	this.detailObj.timeData = this.detailObj.createtime.substring(0,10);
      	console.log(this.detailObj);
      },
      closeDetail(){
      	this.drawerDetail = false;
      },
      currentPageFn(val) {
	      this.pageTotal.currentPage = val;
	      this.getNoticeList();
	   	},
	   	// 直接发布
	   	releases(item){
	   		let obj = {
	   			id: item.id,
					ispush: 1,
					objecttype:1
				};
				api.updateNotice(obj).then(res=>{
					if(res.code == 0){
						this.getNoticeList();
						this.$messageSuccess('发布成功');
					}else{
						this.$messageError(res.msg);
					}
				}).catch(error => {});
	   	},
	   	// 直接取消发布
	   	noRelease(item){
	   		let obj = {
	   			id: item.id,
					ispush: 0,
					objecttype:1
				};
				api.updateNotice(obj).then(res=>{
					if(res.code == 0){
						this.getNoticeList();
						this.$messageSuccess('取消发布成功');
					}else{
						this.$messageError(res.msg);
					}
				}).catch(error => {});
	   	},
		}
	}
</script>

<style lang="scss" scoped>
	.coursenotice_wrap {
		overflow-y: auto;
		.seach_ipt {
			/deep/ .select_class {
				width: 144px;
				float: left;
				margin-right: 14px;
				.el-input__icon {
					line-height: 32px;
				}
				.el-input__inner {
					height: 32px;
					line-height: 32px;
					border: 0;
					background: #F1F2F4;
					border-radius: 2px;
				}
			}
			.select_box {
				float: left;
				width: 230px;
				height: 32px;
				background: #F1F2F4;
				border-radius: 2px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-right: 14px;
				span {
					font-size: 12px;
					color: #A0A0A6;
					margin-left: 14px;
				}
				i {
					width:0px;
					height:16px;
					border:1px solid rgba(188,188,194,1);
				}
				/deep/ .el-input {
					width: 126px;
					.el-input__icon {
						line-height: 32px;
					}
					.el-input__inner {
						height: 32px;
						line-height: 32px;
						border: 0;
						background: #F1F2F4;
						border-radius: 2px;
					}
				}
			}
			/deep/ .ipt {
				float: left;
				width: 240px;
				.el-input__inner {
					height: 32px;
					line-height: 32px;
					border: 0;
					background: #F1F2F4;
					border-radius: 2px;
				}
			}
			.el-button {
				padding: 8px 12px;
				margin-left: 14px;
			}
			.add_notice {
				float: right;
				padding: 8px 42px;
			}
		}
		/deep/ .el-drawer {
			width: 60% !important;
		}
		/deep/ .drawerDetail {
			.el-drawer {
				width: 40% !important;
			}
		}
		.notice_list {
			margin-top: 14px;
			.notice_item {
				height: 96px;
				background: #F6F8FB;
				padding: 18px 20px;
				margin-bottom: 8px;
				.top_head {
					display: flex;
					align-items: center;
					justify-content: space-between;
					.name_status {
						span {
							font-size: 16px;
							color: #0D141E;
						}
						i {
							display: inline-block;
							width:60px;
							height:20px;
							color: #fff;
							font-size: 12px;
							line-height: 20px;
							text-align: center;
							margin-left: 10px;
						}
						.grey {
							background:rgba(153,160,170,1);
						}
						.blur {
							background:rgba(83,151,247,1);
						}
						b {
							font-style: normal;
							font-size: 14px;
							color: #F77981;
							margin-left: -6px;
						}
					}
					.dataTime {
						font-size: 12px;
						color: #5D646E;
					}
				}
				.content {
					font-size: 12px;
					color: #5D646E;
					margin: 10px 0;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					line-height: 20px;
					cursor: pointer;
					min-height: 42px;
				}
				.bottom {
					display: flex;
					align-items: center;
					justify-content: space-between;
					span {
						font-size: 12px;
						color: #0D141E;
					}
					.imgBox {
						display: flex;
						align-items: center;
						justify-content: space-between;
						li {
							display: flex;
							align-items: center;
							justify-content: space-between;
							font-size: 12px;
							color: #5D646E;
							cursor: pointer;
							&:hover{
								i {color: #5397F7;}
							}
						}
						span {
							display: inline-block;
							width: 16px;
							height: 16px;
							margin-left: 16px;
							margin-right: 7px;
						}
						.release {
							span {
								background: url('../../../../../static/images/course/teachClassIcon/fb.png');
            		background-size: 100% 100%;
							}
            	&:hover{
            		span {
            			background: url('../../../../../static/images/course/teachClassIcon/fb_hv.png');
	              	background-size: 100% 100%;
            		}
	            }
						}
						.norelease {
							span {
								background: url('../../../../../static/images/course/teachClassIcon/ch.png');
            		background-size: 100% 100%;
							}
            	&:hover{
            		span {
            			background: url('../../../../../static/images/course/teachClassIcon/ch_hv.png');
	              	background-size: 100% 100%;
            		}
	            }
						}
						.edit {
							span {
								background: url('../../../../../static/images/course/editSourceIcon/edit.png');
            		background-size: 100% 100%;
							}
            	&:hover{
            		span {
            			background: url('../../../../../static/images/course/editSourceIcon/edit-hv.png');
	              	background-size: 100% 100%;
            		}
	            }
						}
						.del {
							span {
								background: url('../../../../../static/images/course/editSourceIcon/delete.png');
            		background-size: 100% 100%;
							}
            	&:hover{
            		span {
            			background: url('../../../../../static/images/course/editSourceIcon/delete-hv.png');
	              	background-size: 100% 100%;
            		}
	            }
						}
					}
				}
			}
		}
		.noList {
			margin-top: 10%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;
			img {
				display: inline-block;
				width: 250px;
				height: 170px;
			}
		}
		.drawer_content,.drawer_detail {
			.content_into {
				overflow-y: auto;
			}
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 64px;
				border-bottom: 2px solid #DDE0E2;
				padding: 0 20px;
				span {
					font-size: 16px;
					color: #0D141E;
				}
				img {
					display: block;
					width: 26px;
					height: 26px;
					cursor: pointer;
				}
			}
			.ipt {
				padding: 0 16px;
				margin-top: 16px;
				p {
					font-size: 12px;
					margin-bottom: 12px;
				}
				.topNum {
					font-size: 14px;
					color: red;
				}
				/deep/ .el-input {
					.el-input__inner {
						height: 42px;
						line-height: 42px;
						border: 0;
						background: #F1F2F4;
						border-radius: 4px;
					}
				}
				.notice_content {
					clear: both;
				}
				.transfer {
					.left {
						width: 100%;
					}
					.left {
						>.el-checkbox {
							margin-bottom: 6px;
							margin-left: 12px;
							/deep/ .el-checkbox__label {
								font-size: 12px;
							}
						}
					}
					.checkbox {
						height: 150px;
						padding: 12px;
						background: #F1F2F4;
						border-radius: 4px;
						overflow-y: hidden;
						overflow-x: auto;
						.el-checkbox-group {
							height: 150px;
							padding: 12px;
							display: flex;
					    flex-flow: column;
					    flex-wrap: wrap;
							.el-checkbox {
								margin-bottom: 10px;
								/deep/ .el-checkbox__label {
									font-size: 12px;
								}
							}
						}
					}
				}
				.ipt_label {
					display: inline-block;
					width: 64px;
					text-align: right;
					font-size: 12px;
					color: #0D0D0D;
				}
			}
			.btn {
				text-align: center;
				margin-top: 10%;
				margin-bottom: 30px;
				.el-button {
					padding: 7px 23px;
					margin-left: 0;
					margin-right: 15px;
				}
			}
		}
		.drawer_detail {
			.content_into {
				padding: 10px 20px;
				p.classNames {
					font-size: 12px;
					color: #0D141E;
					margin-top: 22px;
				}
				.cont {
					h3,.dataTime {
						text-align: center;
					}
					h3 {
						color: #0D141E;
						font-size: 16px;
						margin-bottom: 10px;
					}
					.dataTime {
						color: #858C96;
						margin-bottom: 26px;
					}
					.date_cont {
						font-size: 14px;
						color: #5D646E;
						line-height: 20px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/components/courseNotice.vue